import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// import { ImageSlider } from './ImageSlider';
const ImageSlider = ({ images }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const intervalRef = useRef(null);
    
    const imageArray = Array.isArray(images) ? images : [images];
    
    const styles = {
      sliderContainer: {
        position: 'relative',
        width: '100%',
        height: '250px',
        overflow: 'hidden'
      },
      image: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        transition: 'opacity 0.3s ease'
      },
      dots: {
        position: 'absolute',
        bottom: '10px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: '6px',
        zIndex: '2'
      },
      dot: {
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: '#ccc',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease'
      },
      activeDot: {
        backgroundColor: '#400684'
      }
    };
  
    const startAutoSlide = () => {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % imageArray.length);
      }, 2000);
    };
  
    const stopAutoSlide = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  
    // Clear interval on component unmount
    useEffect(() => {
      return () => stopAutoSlide();
    }, []);
  
    return (
      <div
        style={styles.sliderContainer}
        onMouseEnter={startAutoSlide}
        onMouseLeave={stopAutoSlide}
      >
        <img
          src={imageArray[currentIndex]}
          alt={`Slide ${currentIndex + 1}`}
          style={styles.image}
        />
        
        {imageArray.length > 1 && (
          <div style={styles.dots}>
            {imageArray.map((_, idx) => (
              <div
                key={idx}
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentIndex(idx);
                }}
                style={{
                  ...styles.dot,
                  ...(currentIndex === idx ? styles.activeDot : {})
                }}
              />
            ))}
          </div>
        )}
      </div>
    );
  };
const RelatedProducts = ({ currentProductId }) => {
  // Using the same products data structure
  const products = [
    {
      id: 'RUT956',
      name: 'RUT956',
      images: [
        '/rut956.png',
        '/rut956-1.webp',
        '/rut956-6.webp',
        '/rut956-7.webp'
      ],
      features: ['4G LTE (Cat 4)', '3G, 2G', 'Wi-Fi Multiple Physical Interface']
    },
    {
      id: 'RUT241',
      name: 'RUT241',
      images: [
        '/rut241.png',
        '/rut241-1.png',
        '/rut241-6.webp',
        '/rut241-3.png'
      ],
      features: ['4G LTE (Cat 4)', '3G, 2G', 'Wi-Fi', 'WAN Failover']
    },
    {
      id: 'RUTm50',
      name: 'RUTm50',
      images: [
        '/rutm50.png',
        '/rutm50-1.webp',
        '/rutm50-2.webp',
        '/rutm50-3.webp'
      ],
      features: ['5G/LTE (Cat 19)', 'FCC-certified', '5 x Gigabit Ethernet']
    },
    {
      id: 'RUT241_eSIM',
      name: 'RUT241 eSIM™',
      images: [
        '/rut241-esim.png',
        '/rut241-sim-1.png',
        '/rut241-sim-2.png',
        '/rut241-sim-4.png'
      ],
      features: ['4G/LTE (Cat 4), 3G, 2G', 'eSIM™', 'TPM']
    }
  ];

  const styles = {
    container: {
      padding: '40px 20px',
      maxWidth: '1200px',
      margin: '0 auto'
    },
    heading: {
      fontSize: '32px',
      fontWeight: 'bold',
      color: '#400684',
      marginBottom: '30px',
      fontFamily: 'Oswald, sans-serif'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '20px'
    },
    card: {
      background: '#ffffff',
      borderRadius: '12px',
      padding: '20px',
      position: 'relative',
      minHeight: '430px',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      transition: 'box-shadow 0.3s ease',
      cursor: 'pointer'
    },
    imageContainer: {
      flex: '1',
      marginBottom: '20px'
    },
    bottomSection: {
      marginTop: 'auto',
      display: 'flex',
      alignItems: 'stretch',
      gap: '20px',
      paddingTop: '20px'
    },
    productName: {
      fontSize: '32px',
      fontWeight: 'bold',
      color: '#400684',
      fontFamily: 'Oswald, sans-serif',
      margin: '0',
      flex: '0 0 auto',
      minWidth: '160px',
      paddingRight: '10px'
    },
    separator: {
      width: '2px',
      background: '#e0e0e0',
      margin: '0'
    },
    featureContainer: {
      flex: '1',
      paddingLeft: '10px'
    },
    featuresList: {
      listStyle: 'none',
      padding: '0',
      margin: '0',
      display: 'flex',
      flexDirection: 'column',
      gap: '5px'
    },
    feature: {
      fontSize: '14px',
      color: '#333',
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.5'
    }
  };

  // Filter out the current product and limit to 3 related products
  const relatedProducts = products
    .filter(product => product.id !== currentProductId)
    .slice(0, 3);

  const handleCardClick = (productId) => {
    window.location.href = `/product/${productId}`;
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Related Products</h2>
      <div style={styles.grid}>
        {relatedProducts.map((product) => (
          <div
            key={product.id}
            style={styles.card}
            onClick={() => handleCardClick(product.id)}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
            }}
          >
            <div style={styles.imageContainer}>
              <ImageSlider images={product.images} />
            </div>

            <div style={styles.bottomSection}>
              <h2 style={styles.productName}>{product.name}</h2>
              <div style={styles.separator}></div>
              <div style={styles.featureContainer}>
                <ul style={styles.featuresList}>
                  {product.features.map((feature, index) => (
                    <li key={index} style={styles.feature}>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;